import { useEffect } from 'react';
import { dispatcher } from 'dispatcher';
import { useLocation } from 'react-router-dom';

export const useLegacyPageRenderedTrigger = ({ page, showPageAsPopUp }) => {
    const { pathname } = useLocation();

    useEffect(() => {
        if (page && !showPageAsPopUp) {
            dispatcher.dispatch('page:rendered');
        }
    }, [page, showPageAsPopUp, pathname]);
};
